const payment = {
  en: {
    translation: {
      title: "Continue to payment",
      // CHECKBOX
      agree_terms_and_condition:
        "By clicking on Proceed, the User will place the order and will pay directly to the operator. The User also accepts Emma's",
      terms_and_condition: "Terms and condition",
      and: "and",
      privacy_policy: "Privacy policy",
      emma: "",
      // ALERT SUCCESS
      success_title: "Payment submitted. Thank you!",
      success_cash_title: "Ordered submitted. Thank you!",
      success_description:
        "We are processing your order. You will receive an email summarizing the order",
      // ALERT ERROR
      error_title: "Payment error",
      error_description:
        "We can not processing your order. Please try again later or contact the business",
      // ALERT PAYMENT CASH
      how_pay: "How will you pay?",
      cash_pay_right: "I have the right money",
      cash_pay_20: "I will pay with 20",
      cash_pay_30: "I will pay with 30",
      cash_pay_50: "I will pay with 50",
      cash_pay_100: "I will pay with 100",
      // MEAL VOUCHER
      meal_voucher: "Pay with Meal Voucher",
      payInBoxOffice: 'Pay in Box Office',
      payWithPayPalOrCreditCard:"Pay with credit's card or paypal"
    }
  },
  it: {
    translation: {
      title: "Procedi al pagamento",
      // CHECKBOX
      agree_terms_and_condition:
        "Procedendo l’Utente invia l’ordine ed esegue il pagamento direttamente all’esercente. L’Utente accetta altresì",
      terms_and_condition: "Termini e Condizioni",
      and: "e",
      privacy_policy: "la Privacy Policy",
      emma: "di Emma",
      // ALERT SUCCESS
      success_title: "Pagamento effettuato. Grazie!",
      success_cash_title: "Ordine inviato. Grazie!",
      success_description:
        "Stiamo processando il tuo ordine. Riceverai un'e-mail che riepilogherà l'ordine",
      // ALERT ERROR
      error_title: "Errore di pagamento",
      error_description:
        "Non possiamo processare il tuo ordine. Per favore riprova più tardi o contatta la struttura",
      // ALERT PAYMENT CASH
      how_pay: "Come pagherai?",
      cash_pay_right: "Ho i soldi giusti",
      cash_pay_20: "Pagherò con 20",
      cash_pay_30: "Pagherò con 30",
      cash_pay_50: "Pagherò con 50",
      cash_pay_100: "Pagherò con 100",
      // MEAL VOUCHER
      meal_voucher: "Paga con buoni pasto",
      payInBoxOffice: 'Paga in biglietteria',
      payWithPayPalOrCreditCard:'Paga con carta di credito o paypal'


    }
  }
};

export default payment;
